import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { EpisodeCategory } from '@common/enums';
import type { Process } from '@common/interfaces';
import type { IPatient } from '@common/interfaces/patient';

export type PatientEpisodeCategoryContextValue = Readonly<{
    episodeCategory: EpisodeCategory;
    patient: IPatient;
    processes: Process[];
    reload: () => Promise<void>;
    reloadPatient: () => Promise<void>;
    setSaveStatus: Dispatch<SetStateAction<'saving' | 'saved' | undefined>>;
}>;

export const PatientEpisodeCategoryContext = createContext<PatientEpisodeCategoryContextValue | null>(null);
